function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 48.2L85 77.9V49.6H56.7v43.1L0 122.4l13.2 25 14.7-7.7v94.2h227.6v-94.2l14.7 7.7 13.2-25-141.7-74.2zm85.4 157.4H56.4v-80.8l85.3-44.7 85.3 44.7v80.8h.1z"
})));